module.exports = __webpack_public_path__ + "static/media/Other.2fca3d77.svg";